/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';
import BlurredText from '../../images/blurredtext.png';
import BlurredTextSmall from '../../images/blurredtextsm.png';
import Lock from '../../images/Lock.png';

class AnonCompanyHighlights extends React.Component {
  state = {
    matches: window.matchMedia('(max-width: 600px)').matches,
  };

  componentDidMount() {
    this.mediaMatch = window.matchMedia('(max-width: 600px)');
    this.handler = (e) => this.setState({ matches: e.matches });
    this.mediaMatch.addListener(this.handler);
  }

  componentWillUnmount() {
    this.mediaMatch.removeListener(this.handler);
  }

  render() {
    const backgroundImage = `url(${
      this.state.matches ? BlurredTextSmall : BlurredText
    })`;

    return (
      <div className='max-width-div add-margin'>
        <div className='black-44'>Highlights</div>
        <div id='pseudo-company-highlights-text' style={{ backgroundImage }}>
          <div className='locked-login-block'>
            <img src={Lock} alt='Lock Icon' />
            <div className='sign-up-links'>
              <Link
                className='btn-download w-inline-block'
                target='_blank'
                to='/login'
              >
                Sign in
              </Link>
              &nbsp;or&nbsp;
              <Link
                className='btn-download w-inline-block'
                target='_blank'
                to='/register'
              >
                Join
              </Link>
              &nbsp;to view the key highlights
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AnonCompanyHighlights;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/AnonCompanyHighlights.js